import { render, staticRenderFns } from "./TransferTree.vue?vue&type=template&id=437bd8b6&scoped=true&"
import script from "./TransferTree.vue?vue&type=script&lang=js&"
export * from "./TransferTree.vue?vue&type=script&lang=js&"
import style0 from "./TransferTree.vue?vue&type=style&index=0&id=437bd8b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437bd8b6",
  null
  
)

export default component.exports